import { styled } from '@mui/system'
import { fontSizes, colors } from '../../Components/consts'

export const DraftHeader = styled('h1')(({ theme }) => ({
  fontSize: fontSizes.xlarge,
  margin: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.medium,
    margin: theme.spacing(1, 0),
  },
}))

export const DraftTableCon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  border: `1px solid ${colors.lightestGrey}`,
  borderRadius: '0 0 8px 8px',
  padding: theme.spacing(4, 0),
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
    overflowX: 'scroll',
  },
  '& .innerTableCon': {
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      overflowX: 'scroll',
    },
  },
  '& .draftTable': {
    minWidth: '85vw',
    padding: theme.spacing(1, 2),
    borderCollapse: 'collapse',
    [theme.breakpoints.down('sm')]: {
      minWidth: '95vw',
    },
    '& thead': {
      position: 'sticky',
      top: 0,
      zIndex: 3,
      background: colors.white,
    },
    '& th': {
      fontSize: 14,
      color: colors.text,
      fontWeight: 'normal',
      textTransform: 'uppercase',
      height: theme.spacing(5),
      textAlign: 'left',
      padding: theme.spacing(0.5),
      width: 'auto',
      [theme.breakpoints.down('sm')]: {
        fontSize: 11,
        '&:first-of-type': {
          width: 20,
          textAlign: 'left',
        },
      },
      '&:first-of-type': {
        minWidth: 20,
      },
      '&:nth-of-type(2)': {
        minWidth: 40,
      },
      '&:last-child': {
        textAlign: 'right',
      },
    },
    '& tbody tr': {
      borderTop: `1px solid ${colors.lightGrey}`,
      '&:first-of-type': {
        borderTop: 0,
      },
    },

    '& tbody td': {
      fontSize: 15,
      padding: theme.spacing(1, 0.5),
      color: colors.text,
      width: 'auto',
      textAlign: 'left',
      fontWeight: 400,
      [theme.breakpoints.down('sm')]: {
        fontSize: 10,
        '&:first-of-type': {
          width: 20,
          textAlign: 'left',
        },
      },
      '&:first-of-type': {
        minWidth: 20,
        textAlign: 'left',
        fontWeight: 'bold',
      },
      '&:nth-of-type(2)': {
        minWidth: 40,
        margin: theme.spacing(1),
      },
      '& a': {
        color: colors.text,
        textDecoration: 'none',
      },
      '& svg': {
        width: 18,
        marginLeft: theme.spacing(1),
      },
      '&:last-child': {
        textAlign: 'right',
      },
    },
    '& tfoot p': {
      fontWeight: 'normal',
      fontSize: 14,
    },
  },
}))

export const DraftCol = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  '& > div': {
    '& img': {
      width: 25,
      marginRight: 3,
      [theme.breakpoints.down('sm')]: {
        width: 15,
      },
    },
  },
}))

export const DraftCallout = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  '& .inner': {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    background: 'none',
    borderRadius: 12,
    borderRight: `1px solid ${colors.lightestGrey}`,
    borderTop: `1px solid ${colors.lightestGrey}`,
    borderBottom: `1px solid ${colors.lightestGrey}`,
    borderLeft: `8px solid ${colors.green}`,
    margin: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  '& .calloutOptionRow': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    margin: theme.spacing(0, 1),
    padding: theme.spacing(1),
    borderTop: `3px solid ${colors.lightestGrey}`,
    '&:first-of-type': {
      borderTop: 0,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(0, 0.5),
      padding: theme.spacing(1, 0),
    },
    '& .calloutInfoCol': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      },
      '& .title': {
        fontWeight: 500,
        fontSize: fontSizes.semiLarge,
        margin: theme.spacing(0.5, 1),
        [theme.breakpoints.down('sm')]: {
          fontSize: fontSizes.medium,
          margin: '0 2px',
        },
      },
      '& .description': {
        fontWeight: 400,
        fontSize: fontSizes.medium,
        margin: '1px 15px',
        [theme.breakpoints.down('sm')]: {
          fontSize: fontSizes.small,
          textAlign: 'center',
          margin: '5px 2px',
        },
      },
    },
  },
}))

export const DraftSignupCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  margin: theme.spacing(2, 0),
}))

export const DraftTradeCon = styled('div')(({ theme }) => ({
  margin: theme.spacing(0, 2),
}))

export const DraftTradeList = styled('div')(({ theme }) => ({
  '& p': {
    marginBottom: theme.spacing(-2),
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8rem',
    },
  },
  '& ul': {
    paddingLeft: 15,
    '& li': {
      color: colors.gray.gray70,
      fontSize: fontSizes.small,
      [theme.breakpoints.down('md')]: {
        fontSize: '0.6rem',
      },
    },
  },
}))
